// Shared, mutable session state. LEAF module — imports nothing from the app,
// so editor/preview/select/upload can all read+write it without circular deps.

// The library — hydrated from IndexedDB at startup by library.js. Shape mirrors
// what select.js/upload.js expect: titles[].creatives[].{ files?[], canvases[] }.
export const titles = [];

// Title/creative/file currently being previewed/edited.
export const currentContext = { titleId: null, creativeId: null, fileId: null };
export function setContext(titleId, creativeId, fileId) {
  currentContext.titleId = titleId || null;
  currentContext.creativeId = creativeId || null;
  currentContext.fileId = fileId || null;
}

// The canvas currently open in the editor (null when previewing a raw file or a
// mock source that has not been saved as a canvas yet).
let _currentCanvasId = null;
export function getCurrentCanvasId() { return _currentCanvasId; }
export function setCurrentCanvasId(id) { _currentCanvasId = id || null; }
